import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { FaArrowDown } from "react-icons/fa";
import { BASE_URL, IMAGE_BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";
const DirectorsDetailsModal = React.lazy(() =>
  import("../../components/directoes-details-modal")
);
const BoardOfDirectors = () => {
  const { data, isLoading } = useQuery(["leaderTeams"], async () => {
    const response = await window.fetch(`${BASE_URL}/leader-teams`);
    return await response.json();
  });
  const leader_teams = data?.datas;

  const [showModal, setShowModal] = React.useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = React.useState(null);

  const close = () => setShowModal(false);

  function handleShowUserInfo(selectedIndex) {
    setShowModal(true);
    setSelectedUserIndex(selectedIndex);
  }

  useScrollTop();
  return (
    <section className="me-35 ms-35 mt-7">
      <div className="row">
        {leader_teams?.map((team, index) => (
          <div className="col-12 col-md-6 col-lg-4 " key={index}>
            <div className="mx-2 my-5 review-shadow bg-white rounded-lg position-relative">
              <div>
                <img
                  src={`${IMAGE_BASE_URL}/${team?.image}`}
                  loading="lazy"
                  alt={team?.name}
                  style={{
                    borderRadius: "1rem 1rem 0 0",
                  }}
                  className="img-fluid w-100"
                />
              </div>
              <div className="p-3">
                <h4 className="fs-22 lh-22 mt-2">{team?.name}</h4>
                <p className="fs-14">{team?.designation}</p>
                <button
                  className="text-secondary flex align-items-center fs-12 text-decoration-none text-success bg-white border-0 pb-5"
                  onClick={() => handleShowUserInfo(index)}
                >
                  <span className="text-spanish-gray">
                    <FaArrowDown />
                  </span>
                  <span className="ms-3 fs-14 text-orange-ryb">
                    View Profile
                  </span>
                </button>
                <div className="review-card-border"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <React.Suspense fallback="">
        {showModal && (
          <DirectorsDetailsModal
            userInfo={leader_teams[selectedUserIndex]}
            text_1="Executive Statement"
            text_2="The Office"
            showDialog={showModal}
            close={close}
          />
        )}
      </React.Suspense>
    </section>
  );
};

export default BoardOfDirectors;
